module.exports = __webpack_public_path__ + "img/blueBackArrow.604fe34d.svg";